
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Group,
Tab,
Cell,
TabItem,
XButton,
},
data() {
return {
select: '',
list: ['未完成', '已完成'],
index: 0,
orders_closed: [],
orders_unclosed: [],
role: '',
isid: '',
loadmoreone: '加载更多',
loadmoretwo: '加载更多',
show: false,
hide: false,
isDisabled: false
}
},
methods: {
showMoreorders() {
var offset
var closed
var app = this
this.isDisabled = true
if (this.index === 1) {
offset = this.orders_closed.length
closed = true
} else {
offset = this.orders_unclosed.length
closed = false
}

var token = localStorage.getItem('token')
var opid = localStorage.getItem('userid')

var obj = {
headers: {
token: token,
opid: opid
}
}

AjaxPlugin.$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + this.role + '&offset=' + offset + '&count=10&closed=' + closed, obj)
.then(function (response) {
app.isDisabled = false
if (app.index === 1) {
app.loadmoretwo = '加载中'
if (response.data.content.length > 0) {
app.loadmoretwo = '加载更多'
} else {
app.hide = false
}
} else {
app.loadmoreone = '加载中'
if (response.data.content.length > 0) {
app.loadmoreone = '加载更多'
} else {
app.show = false
}
}
var orders = []
orders = response.data.content
for (var i = 0; i < orders.length; i++) {
if (app.index === 0) {
switch (orders[i]['state']) {
case 'WAIT':
orders[i]['state'] = '待处理'
break
case 'PROCESS':
orders[i]['state'] = '处理中'
break
case 'FAIL':
orders[i]['state'] = '处理失败,待审核'
break
case 'SUCCESS':
orders[i]['state'] = '处理成功,待审核'
break
default:
break
}

switch (orders[i]['canstate']) {
case 'REQUEST':
orders[i]['state'] = '用户取消,待确认'
break
}
}
if (app.index === 1) {
switch (orders[i]['state']) {
case 'WAIT':
orders[i]['state'] = '待处理'
break
case 'PROCESS':
orders[i]['state'] = '处理中'
break
case 'FAIL':
orders[i]['state'] = '处理失败'
break
case 'SUCCESS':
orders[i]['state'] = '处理成功'
break
default:
break
}
}
if (app.index === 1) {
app.orders_closed.push(orders[i])
} else {
app.orders_unclosed.push(orders[i])
}
}
})
.catch(err => {
that.isDisabled = false
})
}
},
created() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this
var app = this
this.$http.get('api/v1/wechat/' + unionid)
.then(function (res) {



if (res.data.length !== 0) {
let account = res.data[0].account
localStorage.setItem('account', account)
that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then(function (res) {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var opid = res.data.userid
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
that.$http.get('api/v1/accounts/' + res.data.userid, obj)
.then(function (response) {
for (var i = 0; i < response.data.length; i++) {

if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
that.role = response.data[i].type
break;
}
if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
that.isid = response.data[i].type
}
}

if (that.role == 'EXPT' || that.role == 'SRVP') {

AjaxPlugin.$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + app.role + '&offset=0&count=10&closed=true', obj)
.then(function (response) {

app.orders_closed = response.data.content
if (response.data.total > 10) {
app.hide = true;
}
for (var i = 0; i < app.orders_closed.length; i++) {
switch (app.orders_closed[i]['state']) {
case 'WAIT':
app.orders_closed[i]['state'] = '待处理'
break
case 'PROCESS':
app.orders_closed[i]['state'] = '处理中'
break
case 'FAIL':
app.orders_closed[i]['state'] = '处理失败'
break
case 'SUCCESS':
app.orders_closed[i]['state'] = '处理成功'
break
default:
break
}
}
})


AjaxPlugin.$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + app.role + '&offset=0&count=10&closed=false', obj)
.then(function (response) {

app.orders_unclosed = response.data.content
if (response.data.total > 10) {
app.show = true;
}
for (var i = 0; i < app.orders_unclosed.length; i++) {
switch (app.orders_unclosed[i]['state']) {
case 'WAIT':
app.orders_unclosed[i]['state'] = '待处理'
break
case 'PROCESS':
app.orders_unclosed[i]['state'] = '处理中'
break
case 'FAIL':
app.orders_unclosed[i]['state'] = '处理失败,待审核'
break
case 'SUCCESS':
app.orders_unclosed[i]['state'] = '处理成功,待审核'
break
default:
break
}
switch (app.orders_unclosed[i]['canstate']) {
case 'REQUEST':
app.orders_unclosed[i]['state'] = '用户取消,待确认'
break
}
}
})


} else {
var iden
if (that.isid == 'INDV') {
iden = '个人专家'
}




that.$vux.confirm.show({
title: '',
content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
onConfirm() {
that.$router.push({name: 'addexpertInfo'})
},
onCancel() {
WeixinJSBridge.call('closeWindow');
}
})
}

})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

} else {
localStorage.setItem('repair','engineer')
that.$router.push({name: 'login'})
}
})
.catch(function (error) {
console.log(error.response)
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})


},
beforeRouteLeave(to, from, next) {
if (to.name == 'records') {
next()
} else {
localStorage.removeItem('order')
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/engineer.vue